/**
 * The confirmation the popup covers itself with. Only one can be up at a time, and `null` on the
 * signal that holds it means the popup is showing none.
 */
export enum DialogEventOverlay {
  Discard = 'discard',
  Hide = 'hide',
}
